import { TicketDetail } from "@features/tickets/components/detail/TicketDetail";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/tickets/$id/view")({
  loader: requirePermission(PERMISSIONS.TICKETS.TICKETS.VIEW),
  staticData: {
    title: "Détail du ticket",
    showInTab: false,
    showInBreadcrumb: true,
  },
  component: TicketDetailPage,
});

function TicketDetailPage() {
  return <TicketDetail />;
}
